'use client';

import { Fragment, useState } from 'react';

import { LineArrowDownIcon } from '@/app/_components/icons/line/LineArrowDownIcon';
import Skeleton from '@/app/(football)/[team]/_components/common/Skeleton';
import UsePointLoungeListItem from '@/app/(football)/[team]/_components/common/UsePointLoungeListItem';
import { useTeamConfig } from '@/app/(football)/[team]/_context/context';
import { useGetPointUseWithInitQuery } from '@/store/server/common/football/football.query';


const ITEMS_PER_PAGE = 5;

export default function UseList() {
  const { originalsName } = useTeamConfig();

  const { data: pointUseList, isLoading, isError } = useGetPointUseWithInitQuery({ originalsName });

  const [page, setPage] = useState(1);
  const visibleList = pointUseList?.rows?.slice(0, page * ITEMS_PER_PAGE);
  const hasMore = pointUseList?.rows && visibleList && visibleList.length < pointUseList.rows.length;

  if (isLoading) {
    return (
      <div className="mt-8 mb-10 flex w-full flex-col items-center gap-6">
        <div className="flex w-full flex-col gap-6">
          {Array.from({ length: 5 }).map((_, index) => (
            <div key={`skeleton-${index}`} className="flex w-full flex-row gap-4">
              <Skeleton width={120} height={120} borderRadius={4} />
              <div className="flex flex-1 flex-col justify-between gap-4">
                <div className="flex flex-col gap-2">
                  <Skeleton width={100} height={22} />
                  <Skeleton width={200} height={20} />
                </div>
                <Skeleton width={120} height={20} />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (isError || !pointUseList) {
    return (
      <div className="mt-8 mb-10 flex w-full flex-col items-center gap-6">
        <div className="flex w-full items-center justify-center p-6 typo-body-2 text-white">
          데이터를 불러오는 중 오류가 발생했습니다.
        </div>
      </div>
    );
  }

  if (pointUseList.rows.length === 0) {
    return (
      <div className="mt-8 mb-10 flex w-full flex-col items-center gap-6">
        <div className="flex w-full items-center justify-center p-6 typo-body-2 text-white">
          상품 준비 중 입니다.
        </div>
      </div>
    );
  }

  return (
    <div className="mt-8 mb-10 flex w-full flex-col items-center gap-6">
      <div className="flex w-full flex-col">
        {visibleList?.map((item, index) => (
          <Fragment key={item.methodIdx}>
            <UsePointLoungeListItem
              methodIdx={item.methodIdx}
              type={item.type}
              title={item.title}
              image={item.image}
              point={item.point}
              remainAmount={item.remainAmount}
              startDttm={item.startDttm}
              endDttm={item.endDttm}
            />
            {index < visibleList.length - 1 && (
              <div className="my-6 min-h-[1px] w-full shrink-0 bg-point-lounge-list-divider" />
            )}
          </Fragment>
        ))}
      </div>
      {hasMore && (
        <button
          onClick={() => setPage((prev) => prev + 1)}
          className="flex items-center justify-center gap-1 border-none bg-none typo-body-6 text-white"
        >
          더보기
          <LineArrowDownIcon size={14} color="white" />
        </button>
      )}
    </div>
  );
}
